<script lang="ts">
	import NoTraffic from '$assets/traffic/no-traffic.svg';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Image from '$lib/components/atoms/image/Image.svelte';
	import * as m from '$paraglide/messages';
	import { createEventDispatcher } from 'svelte';

	export let text: string;
	export let refresh: boolean;

	const dispatch = createEventDispatcher<{ retry: void }>();
</script>

<div class="flex flex-col gap-4">
	<div class="flex flex-col items-center gap-2">
		<Image src={NoTraffic} alt={text} objectFit="contain" class="h-22 w-22" />
		<div class="text-md text-center">{text}</div>
	</div>
	{#if refresh}
		<Button
			text={m.action__retry()}
			icon="autorenew"
			class="w-fit m-auto"
			onclick={() => dispatch('retry')}
		/>
	{/if}
</div>
